import { render, staticRenderFns } from "./fake-home.vue?vue&type=template&id=8e2bd100&"
import script from "./fake-home.vue?vue&type=script&lang=js&"
export * from "./fake-home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports